import axios from 'axios';
import { apiConfig } from '@/config/apiConfig';

// Use /supabase-fn path — proxied by Vite in dev and Vercel rewrites in prod
const baseURL = '/supabase-fn';

const trackingApiClient = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Reuse JWT token from localStorage/sessionStorage (same pattern as main apiClient)
trackingApiClient.interceptors.request.use((config) => {
  const token =
    localStorage.getItem(apiConfig.auth.tokenKey) ||
    sessionStorage.getItem(apiConfig.auth.tokenKey);

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default trackingApiClient;
